export default "__VITE_ASSET__0f78987e__"